"use client";
import React, { useState } from "react";
import Image from "next/image";
import DemoImageViewer from "./DemoImageViewer";
import ImageViewer from "./ImageViewer";
export default function Gallery(props) {
  const galleries = props.data.attributes.gallery;
  const demoImages = props.demoImages;
  const [selectedImage, setSelectedImage] = useState(null);
  const [showViewer, setShowViewer] = useState(false);

  const [selectedDemoImage, setSelectedDemoImage] = useState(null);
  const [selectedDemoImageIndex, setSelectedDemoImageIndex] = useState(0);
  const [showDemoViewer, setShowDemoViewer] = useState(false);
  return (
    <>
      <div>
        <div className="page-heading center">
          <h1>Demo Images</h1>
        </div>
      </div>
      <div className="gallery">
        <div className="gallery-images-wrapper">
          {demoImages &&
            demoImages.map((image, index) => (
              <div
                className="image-wrapper"
                key={image.id}
                onClick={() => {
                  setSelectedDemoImage(image);
                  setShowDemoViewer(true);
                  setSelectedDemoImageIndex(index);
                }}
              >
                <Image
                  src={image.fileLink}
                  height={1920}
                  width={1080}
                  alt={image.altText}
                />
              </div>
            ))}
        </div>
      </div>
      {galleries.map((gallery) => (
        <div key={gallery.id}>
          <div className="page-heading center">
            <h2>Images</h2>
          </div>
          <div className="gallery" key={gallery.id}>
            <div className="gallery-images-wrapper">
              {gallery.images.data.map((image, index) => (
                <div
                  className="image-wrapper"
                  key={image.id}
                  onClick={() => {
                    setSelectedImage(image);
                    setShowViewer(true);
                  }}
                >
                  <Image
                    src={image.attributes.url}
                    height={1920}
                    width={1080}
                    alt={
                      image.attributes.alertnativeText ||
                      `Timberline ${gallery.title} images`
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      {showViewer && (
        <ImageViewer
          data={galleries}
          selectedImage={selectedImage}
          close={() => setShowViewer(false)}
        />
      )}
      {showDemoViewer && (
        <DemoImageViewer
          data={demoImages}
          selectedImage={selectedDemoImage}
          selectedDemoImageIndex={selectedDemoImageIndex}
          close={() => setShowDemoViewer(false)}
        />
      )}
    </>
  );
}
